export default __webpack_public_path__ + "static/media/logo-yclick-vertical.52a6fde3.svg";